/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListAdditionalQualificationsParams,
  PaginatedAdditionalQualifications,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Additional Qualifications
 */
export const listAdditionalQualifications = (
    params?: MaybeRefOrGetter<ListAdditionalQualificationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAdditionalQualifications>(
      {url: `/additional_qualifications`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAdditionalQualificationsQueryKey = (params?: MaybeRefOrGetter<ListAdditionalQualificationsParams>,) => {
    return [
    'additional_qualifications', ...(params ? [params] : [])
    ] as const;
    }


export const getListAdditionalQualificationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdditionalQualifications>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAdditionalQualificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdditionalQualifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAdditionalQualificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdditionalQualifications>>> = ({ signal }) => listAdditionalQualifications(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdditionalQualifications>>, TError, TData>
}

export type ListAdditionalQualificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdditionalQualifications>>>
export type ListAdditionalQualificationsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Additional Qualifications
 */

export function useListAdditionalQualifications<TData = Awaited<ReturnType<typeof listAdditionalQualifications>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAdditionalQualificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdditionalQualifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdditionalQualificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






